/**
 * 日付をフォーマットする
 * @param  {Date}   date     日付
 * @param  {String} [format] フォーマット
 * @return {String}          フォーマット済み日付
 *
 * @usage formatDate(new Date('2014/1/23'), 'MM月DD日'); // 01月23日
 */
var formatDate = function (date, format) {
    if (!format) format = 'YYYY-MM-DD hh:mm:ss.SSS';
    format = format.replace(/YYYY/g, date.getFullYear());
    format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
    format = format.replace(/DD/g, ('0' + date.getDate()).slice(-2));
    format = format.replace(/hh/g, ('0' + date.getHours()).slice(-2));
    format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2));
    format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2));
    if (format.match(/S/g)) {
        var milliSeconds = ('00' + date.getMilliseconds()).slice(-3);
        var length = format.match(/S/g).length;
        for (var i = 0; i < length; i++) format = format.replace(/S/, milliSeconds.substring(i, i + 1));
    }
    return format;
};

/**
 * 日付を加算する
 * @param  {Date}   date       日付
 * @param  {Number} num        加算数
 * @param  {String} [interval] 加算する単位
 * @return {Date}              加算後日付
 *
 * @usage
 * addDate(new Date('2014/1/23'), 1); // 2014/1/24
 * addDate(new Date('2014/2/23'), 1, 'MM'); // 2014/2/23 月が加算される
 */
var addDate = function (date, num, interval) {
    switch (interval) {
        case 'YYYY':
            date.setYear(date.getYear() + num);
            break;
        case 'MM':
            date.setMonth(date.getMonth() + num);
            break;
        case 'hh':
            date.setHours(date.getHours() + num);
            break;
        case 'mm':
            date.setMinutes(date.getMinutes() + num);
            break;
        case 'ss':
            date.setSeconds(date.getSeconds() + num);
            break;
        default:
            date.setDate(date.getDate() + num);
    }
    return date;
};
/**
 * 2つの日付の差を計算する
 * @param  {Date}   date1      日付1
 * @param  {Date}   date2      日付2
 * @param  {String} [interval] 差の単位
 * @return {Number}            2つの日付の差
 * @usage
 * dateDiff(new Date('2014/1/1'), new Date('2012/1/2')); // 1
 * dateDiff(new Date('2014/1/1 12:00:00'), new Date('2012/1/2 00:00:00')); // 0 翌日だけど24時間経っていないので0
 * dateDiff(new Date('2014/1/1'), new Date('2013/1/1'), 'YYYY'); // -1
 */
var dateDiff = function (date1, date2, interval) {
    var diff = date2.getTime() - date1.getTime();
    switch (interval) {
        case 'YYYY':
            var d1 = new Date(date1.getTime());
            var d2 = new Date(date2.getTime());
            d1.setYear(0);
            d2.setYear(0);
            var i;
            if (diff >= 0) {
                i = d2.getTime() < d1.getTime() ? -1 : 0;
            } else {
                i = d2.getTime() <= d1.getTime() ? 0 : 1;
            }
            return date2.getYear() - date1.getYear() + i;
            break;
        case 'MM':
            var d1 = new Date(date1.getTime());
            var d2 = new Date(date2.getTime());
            d1.setYear(0);
            d1.setMonth(0);
            d2.setYear(0);
            d2.setMonth(0);
            var i;
            if (diff >= 0) {
                i = d2.getTime() < d1.getTime() ? -1 : 0;
            } else {
                i = d2.getTime() <= d1.getTime() ? 0 : 1;
            }
            return ((date2.getYear() * 12) + date2.getMonth()) - ((date1.getYear() * 12) + date1.getMonth()) + i;
            break;
        case 'hh':
            return ~~(diff / (60 * 60 * 1000));
            break;
        case 'mm':
            return ~~(diff / (60 * 1000));
            break;
        case 'ss':
            return ~~(diff / 1000);
            break;
        default:
            return ~~(diff / (24 * 60 * 60 * 1000));
    }
};
/******************************************************************
 *
 * 時差を吸収して日付を返す
 *
 ******************************************************************/
function parseDate(str) {

    var date = new Date(str);

    var timezoneOffsetMinutes = date.getTimezoneOffset() * 60000;

    // 実行環境と時差が生じている場合(offsetがマイナス)は誤差を吸収する
    if (timezoneOffsetMinutes < 0) {
        var diffTime = date.getTime() + timezoneOffsetMinutes;
        date = new Date(diffTime);
    }

    return date;
}

/******************************************************************
 *
 * 午前かどうかを判定する
 * date.getHours()を引数に渡す
 *
 ******************************************************************/
function _isAm(hours) {
    return hours < 12;
}


/******************************************************************
 *
 * 曜日を算出する
 *
 ******************************************************************/
function youbi(date, prefix, suffix) {

    prefix = isset(prefix) ? prefix : '';
    suffix = isset(suffix) ? suffix : '';

    if (is_string(date)) {
        // 年月日を整形する
        date = date.replace(/年|月/g, '-');
        date = date.replace(/日/g, '');

        // Objectに変換する
        date = new Date(
            date.indexOf('gmt') !== -1
                ? date
                : date + ' gmt');
    }

    return prefix
        + ["日", "月", "火", "水", "木", "金", "土"][date.getDay()]
        + suffix;

}